import { apiClient } from "@/services/api";

export default {
  sendEnquiry(data) {
    return apiClient.post("/enquiry", data);
  }
};
